import { IApikey, Apikey } from "@/entities";
import { IApikeyRepository } from "./apikey.types";
import { signedRequest } from '@/utils/signedRequest';
import getEndpoint from '@/utils/domain';
import { Auth } from "@aws-amplify/auth";
import { API } from "aws-amplify";

export const GET_APIKEY_ENDPOINT = getEndpoint("/auth/apikey/get", true);

export class ApikeyAPIRepository implements IApikeyRepository {
    async get(): Promise<IApikey | undefined> {
        const credentials = await Auth.currentCredentials();
        console.log({ credentials }, GET_APIKEY_ENDPOINT);

        const response = await signedRequest("GET", GET_APIKEY_ENDPOINT, null, credentials);
        console.log("apikey", { response });

        const apikey = new Apikey(response.data);
        return apikey;
    }

    async getApikey(): Promise<any> {
        const response = await API.post("saletoolapi", "/apikey", {});
        return JSON.parse(atob(response))
    }
}